/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import links from '../../../../config/links';

import styles from './eventCreate.scss';

const StepHeader = (props) => {
    const {
        currentStep,
        showStepHeader,
        stepTitles,
        totalSteps,
        editing,
        openModal,
        hideHealthAndSafety,
        hideUtrEventVideo,
    } = props;

    return (
        <>
            {showStepHeader && (
                <div className={`step-header ${currentStep === 1 ? '' : 'mt40'} mb24`}>
                    {!hideHealthAndSafety && (
                        <div className="alert alert-warning alert-warning-utr" role="alert">
                            <div>
                                To learn more about creating events <a href={links.createEventArticle} target="_blank">Click here</a>
                            </div>
                        </div>
                    )}
                    <div className="text-highlight2">STEP {currentStep}/{totalSteps}</div>
                    <h5 className="text-uppercase">
                        {stepTitles && stepTitles.stepTitle && (
                            <>
                                {stepTitles.stepTitle}
                            </>
                        )}
                        {currentStep === 1 && !editing && !hideUtrEventVideo && (
                            <div
                                className={`${styles.videoLink} text-highlight2 text-teal`}
                                onClick={() => {
                                    openModal('video1');
                                }}
                            >
                                <i className="fas fa-play" /> UTR Sports Events
                            </div>
                        )}
                    </h5>
                    {stepTitles && stepTitles.stepSubTitle && (
                        <div className="subtitle">
                            {stepTitles.stepSubTitle}
                        </div>
                    )}
                </div>
            )}
        </>
    );
};

export default StepHeader;
